export const IMG_ERROR = require("./img/error.png")

export const NOTIFICATION_AUDIO = require("./audio/notification.mp3")
